import React, { forwardRef, ReactNode } from 'react';
import { TextAction } from '#components/text-action/text-action.tsx';
import { GDSCustomizableComponent } from '#src/types.ts';
import { getLinkOrButtonProps } from '../utils/get-link-or-button-props';

interface GDSLinkRendererProps extends GDSCustomizableComponent {
  heading: ReactNode;
  href?: string;
  linkAs?: React.ElementType;
  onClick?: (e: React.MouseEvent) => void;
}

export const ConditionalLinkRenderer = forwardRef<
  HTMLAnchorElement | HTMLButtonElement,
  GDSLinkRendererProps
>(({ css, heading, href, onClick, linkAs, ...extraProps }, ref) => {
  if (onClick || href) {
    const linkProps = getLinkOrButtonProps(onClick, href, linkAs);

    return (
      <TextAction
        ref={ref}
        {...linkProps}
        className="GDS-composable-card-action"
        css={css}
        {...extraProps}
      >
        {heading}
      </TextAction>
    );
  }
  return <span>{heading}</span>;
});
